import type { Project } from 'types';
import type { CoursePdfFormValue } from 'utils/course-pdf';

export type ProjectFormValues = Omit<
  Project,
  'coursePdfFile' | 'coursePdfPreview'
> & {
  coursePdfFile?: CoursePdfFormValue;
  coursePdfPreview?: File | Project['coursePdfPreview'];
};

export type ProjectWritePayload<T> = Omit<
  T,
  'coursePdfFile' | 'coursePdfPreview' | 'coursePdfPreviewUrl'
> & {
  coursePdfFile?: null;
  coursePdfPreview?: null;
};

export function projectRequestBody<
  T extends {
    coursePdfFile?: CoursePdfFormValue;
    coursePdfPreviewUrl?: string | null;
    coursePdfPreview?: File | Project['coursePdfPreview'];
  },
>(data: T): FormData | ProjectWritePayload<T> {
  const { coursePdfFile, coursePdfPreview, ...properties } = data;
  const fields = { coursePdfFile, coursePdfPreview };
  const payload: Record<string, unknown> = { ...properties };
  delete payload.coursePdfPreviewUrl;
  let body: FormData | undefined;
  for (const [name, value] of Object.entries(fields)) {
    if (value instanceof File) {
      body ??= new FormData();
      body.append(name, value);
    } else if (value === null) payload[name] = null;
    // Existing storage metadata is read-only; omission keeps the saved file.
  }
  if (!body) return payload as ProjectWritePayload<T>;
  body.append('data', JSON.stringify(payload));
  return body;
}
